import Spinner from "react-bootstrap/Spinner";

export default function LoadingBox({ children, inline }) {
  return (
    <div className={inline ? "loading-box-inline" : "loading-box"}>
      <Spinner animation="border" role="status" className="text-primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      {inline ? (
        <span>{children}</span>
      ) : (
        <div>
          <span>{children}</span>
        </div>
      )}
    </div>
  );
}
